module.exports = __webpack_public_path__ + "img/inmate.7fe4349d.png";